import script from "./Maintenance.vue?vue&type=script&lang=ts&setup=true"
export * from "./Maintenance.vue?vue&type=script&lang=ts&setup=true"

import "./Maintenance.vue?vue&type=style&index=0&id=510b022f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-510b022f"]])

export default __exports__